<template>
  <b-container class="card-container">
    <b-card>
      <template v-slot:header>
        <span class="breadcrumbs"><b-link :to="{name: `image_templates`}">Image Templates</b-link> / Create</span>
      </template>

      <b-form @submit.stop.prevent="create_item">
        <b-form-group invalid-feedback="Must be greater then 4 character">
          <b-form-input v-model="item.name" required placeholder="Image template name" :state="validate_state('name')" style='max-width: 264px'></b-form-input>
        </b-form-group>

        <!-- TODO -->
        <ImageEditor :image_template_id="item_id" ref="image_editor" />

        <LoadingButton type="submit" variant='primary' :loading="is_saving" class="mt-4">Save</LoadingButton>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators"
import ItemMixin from "@/mixins/Item.js"
import { db, storage, FieldValue, config, _firebase } from '@/main.js'
import api from '@/lib/api.js'
import constants from '@/lib/constants.js'
import ImageEditor from '@/components/ImageEditor.vue'

export default {
  metaInfo: {title: 'Image Template create'},
  mixins: [ItemMixin],
  components: {ImageEditor},
  validations: {
    item: {
      name: {required, minLength: minLength(3)},
    }
  },
  firestore: function () {
    return {
      _item: db.collection(this.collection).doc(this.item_id),
    }
  },
  data() {
    let item_id = db.collection('random').doc().id

    return {
      item_id: item_id,
      collection: 'image_template',
      item: {
        status: 'complete',
        name: '',
        images_count: 0,
        svg: null,
        image: null
      },
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'image_template') {
      next()
      return
    }

    const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    if (answer) {
      next()
    } else {
      next(false)
    }
  },
  methods: {
    async do_before() {
      let result = await this.$refs.image_editor.export_image()

      if (!result) {
        await this.$swal({title: 'No image created', text: "Please create an image template", icon: 'warning'})
        return false
      }

      this.item.svg = result.svg
      this.item.image = result.image
    },
    async do_after() {
      await db.collection('user').doc(this.profile.id).update({updated: new Date(), image_templates_count: FieldValue.increment(1)})
    }
  }
}
</script>

<style>

</style>
